import { RegistrationCivilUnionFormVM } from 'mutation/view-models/registration-civil-union';
import { transformCivilStatus } from 'shell/utils/consult-person/request-transformer/marital-status/civil-status';
import { RequestRegistrationCivilUnion } from 'shell/models/register-civil-union';
import { transformCivilUnionAnpr05 } from 'shell/utils/consult-person/request-transformer/marital-status/civil-union-anpr-05';

export const transformerRequestRegistrationCivilUnionData = (
  values: RegistrationCivilUnionFormVM
): RequestRegistrationCivilUnion => {
  const statoCivile = transformCivilStatus(values.civilStatus);

  return {
    statoCivile,
    datiControllo: {
      tipoMutazione: ['18', '01'],
    },
    generalitaPerRicerca: {
      ...(values.person?.generality || {}),
    },
    generalitaDaModificare: {
      generalita: {
        ...(values.person?.generality || {}),
      },
    },
    testataRichiesta: {
      dataDecorrenza: values.editDataControl?.dateValidity?.toFormat('yyyy-MM-dd') || '',
    },
    unioneCivile: values.civilUnion
      ? transformCivilUnionAnpr05({
          ...(values.civilUnion || {}),
          eventDate: values.civilUnion.dateEvent,
          italian: values.civilUnion.italian
            ? {
                location: values.civilUnion.italian.locality,
                municipality: values.civilUnion.italian.municipality,
                province: values.civilUnion.italian.municipality?.province,
              }
            : undefined,
          foreign: values.civilUnion.foreign
            ? {
                municipality: values.civilUnion.foreign.municipalityForeign,
                province: values.civilUnion.foreign.provinceForeign,
                state: values.civilUnion.foreign.foreignState,
              }
            : undefined,
          digital: values.civilUnion.digital || undefined,
        })
      : undefined,
  };
};
